import { cargoViewsT, CargoView } from "../cargo-views/types";
import { editCargoOutputT } from "../../app/cargo-dialog/types";
import * as t from "io-ts";

export const orderViewsT = cargoViewsT;
export const orderT = editCargoOutputT;

export type Order = t.TypeOf<typeof orderT>;
export type OrderView = CargoView;
